import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import FAQ from '../components/FAQ';
import Carousel from '../components/Carousel';
import WhyTalk from '../components/WhyTalk';

export default function Hero(){
  return (
    <div>
      <header id="home">
        <div className="hero-min-bg" aria-hidden="true">
          <svg className="bg-lines" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M -50 200 Q 100 100, 300 50" className="bg-arc" />
            <path d="M 700 -50 Q 850 100, 1000 300" className="bg-arc" />
            <path d="M -100 600 Q 150 550, 400 600" className="bg-arc" />
            <path d="M 900 700 Q 1050 650, 1200 700" className="bg-arc" />
            <path d="M 400 300 Q 600 250, 800 300" className="bg-arc center" />
          </svg>

          <div className="blob blob-1" />
          <div className="blob blob-2" />
          <div className="blob blob-3" />
          <div className="blob blob-4" />
          <div className="blob blob-5" />

          <div className="geom geom-1" />
          <div className="geom geom-2" />
          <div className="geom geom-3" />
          <div className="geom geom-4" />
          <div className="geom geom-5" />

          <div className="ring ring-1" />
          <div className="ring ring-2" />

          <div className="dots">
            {Array.from({length: 14}).map((_, i) => (
              <span key={i} className={`dot dot-${i+1}`} />
            ))}
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 scroll-reveal">
              <h1 className="hero-headline fw-bold">360° Digital Marketing <span className="gradient-text">Excellence</span></h1>
              <p className="lead text-muted">Transform your brand with comprehensive digital marketing solutions. From strategy to execution, we deliver results that matter.</p>
              <div className="d-flex gap-2 mb-4">
                <Link to="/contact" className="btn btn-primary-custom">Start Your Journey</Link>
                <Link to="/portfolio" className="btn btn-outline-custom">View Our Work</Link>
              </div>
              <div className="row text-center">
                <div className="col-4">
                  <div className="stats-number">20+</div>
                  <div className="text-muted">Happy Clients</div>
                </div>
                <div className="col-4">
                  <div className="stats-number">150+</div>
                  <div className="text-muted">Projects Done</div>
                </div>
                <div className="col-4">
                  <div className="stats-number">98%</div>
                  <div className="text-muted">Success Rate</div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 scroll-reveal">
              <div className="marketing-visual">
                <img src="/images/Heroo.png" alt="SocialManiacs Logo" className="logo-hero" />
              </div>
            </div>
          </div>
        </div>
      </header>
     
      <WhyTalk />
      <FAQ />
       <Carousel />
    </div>
  );
}
